var ControllersEnum;
(function (ControllersEnum) {
    ControllersEnum["TodayButton"] = "TODAY_BUTTON";
    ControllersEnum["TimezonePicker"] = "TIMEZONE_PICKER";
    ControllersEnum["MonthPicker"] = "MONTH_PICKER";
    ControllersEnum["Options"] = "OPTIONS";
    ControllersEnum["Children"] = "CHILDREN";
})(ControllersEnum || (ControllersEnum = {}));
export default ControllersEnum;
//# sourceMappingURL=ControllersEnum.js.map